import { Link, useParams, useSearchParams } from "react-router-dom";
import IMAGES from "../../../../assets/images/images";
import {
  ChildContainer,
  Container,
} from "../../../../components/Container/Containers";
import { Search } from "../../../../components/search/search";
import NewCustomer from "../add/NewCustomer.container";
import styles from "./CustomerViewer.module.css";
import CustomerDetail from "../detail/CustomerDetail.container";
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { formatSecondsToDate } from "../../../../utils/dateTime";
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../../../../components/loader/Loader";
import { EmptyContainer } from "../../../dashboard/graphs/component/component";
import { useNavigate } from "react-router-dom";
import SectionGuard from "../../../../hoc/guards/SectionGuard";
import CAN from "../../../../casl/can";
import { Action, Resource } from "../../../../casl/constants";
import { computeWeightedWidths, filterAndMapIds, formatDate, usePopupPosition } from "../../../../utils/arrayUtils";
import Table from "../../../../components/table/Table";
import { COLUMN_KEYS, customerListcolumnConfig, CustomerSortOptions, FILTER_KEYS, serviceType, SORT_FIELDS, SORT_ORDER, UserManagementTab } from "../../../../utils/constants/userManagementConstant";
import SecondaryTooltip from "../../../../components/secondaryToolTip/secondaryToolTip";
import { AppliedFilter, Filter } from "../../../../components/filter/filter";
import { hasValidFincaTadigCode } from "../../../../utils/constants/fincaConstant";
import { Incident_Service_Type_Values } from "../../../../utils/constants/incidentConstants";
import { allCount, checkAllFalse, handleDownload, hasOneItsmServiceName } from "../../../../utils/utils";
import Status from "../../../../components/status/Status";
import ListSorter from "../../../../components/listSorter/ListSorter";
import DetailsTooltip from "../../../../components/detailsTooltip/detailsTooltip";


const CustomerViewer = ({ list,allCustomerList,myRights, isLoading,getAllCustomerList, getCustomerList,next,allCustomerOption,notificationdata,ReadNotification,filterCustomers,...props }) => {
  const { position, columnRef, iconRef, calculatePosition } = usePopupPosition(300);
  const navigate = useNavigate()
  const services = [
    { id: 'all', label: 'All', count: allCount(Object.keys(props.statusCount ?? {}).length > 0 ? props?.statusCount : 0), className: 'statusAll',color: '#CCCCCC',outline:"#9E9E9E" },
    { id: 'ipx_service', label: 'IPX Service', count: props?.statusCount?.ipx_service ?? 0,color: '#FFF1BB',infoMessage : "New",outline:"#F4D55B" },
    { id: 'ivc_service', label: 'International Voice Service', count: props?.statusCount?.ivc_service ?? 0, color: '#FFE1AB', infoMessage: "In Progress",outline:"#F4B035" },
  ];
  const defaultStatuses = services.reduce((acc, status) => ({ ...acc, [status.id]: true }),{});
  const checkedStatuses = props.statusFilter || defaultStatuses;
  // const [checkedStatuses, setCheckedStatuses] = useState(services.reduce((acc, status) => ({ ...acc, [status.id]: true }), {}));
  const handleStatusChange = (newCheckedStatuses) => {
    // setCheckedStatuses(newCheckedStatuses);
    props.setStatusFilter(FILTER_KEYS.CUSTOMER,newCheckedStatuses);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");
  const [sortConfig, setSortConfig] = useState({field: SORT_FIELDS.ORGANISATION_NAME,order: SORT_ORDER.ASC});
  const [filterState, setFilterState] = useState({
    isOrgnameFilter: false,
    selectedOrgNameOptions: props?.columnFilters?.orgName||[],
    isServiceTypeFilter: false,
    selectedServiceTypeptions: []
  });

  let [searchKeyValue, setSearchKeyValue] = useState("");
  const getSearchKeyValue = (e) => {
    setSearchKeyValue(e.target.value);
  };
  const filterData = () => {
    const searchKey = searchKeyValue.trim();
    const cp_name = myRights?.cpName;
    const uniqueCustomerRefId = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
    let serviceFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
    const sort = `${sortConfig.field}:${sortConfig.order}`;
    getCustomerList(cp_name, searchKey, "", uniqueCustomerRefId,serviceFilter,sort);
  };

  // const onKeyDownHandler = (e) => {
  //   if (e.key === "Enter") {
  //     const orgName = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
  //     const serviceType = filterState.selectedServiceTypeptions.map((item) => item.value).join(",");
  //     filterData(orgName, serviceType);
  //   }
  // };

  
  const handleSort = (field) => {
    setSortConfig((prev) => ({field,order : prev.field === field && prev.order === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC,}));
  };

  useEffect(() => {
    filterData();
    window.scrollTo(0,0);
  }, [filterState.selectedOrgNameOptions,checkedStatuses,sortConfig]);

  // useEffect(() => {
  //   if (!customerId) {  // if null then its listing page and call listing api
  //       getCustomerList();
  //   }
  // }, [customerId]);
useEffect(() => {
  props?.getUserReport();
  getAllCustomerList();
  props?.getFilteredCustomers();
}, []);
  const removeCustomerId = useCallback(() => {
    setSearchParams((p) => {
      p.delete("customerId");
      return p;
    });
  }, [setSearchParams]);

  useEffect(() => {
    return () => {
      if (customerId) {
        removeCustomerId();
      }
    };
  }, [customerId, removeCustomerId]);
  if (customerId) {
    return <CustomerDetail onBack={removeCustomerId} customerId={customerId} />;
  }

  const handleOrgNameFilterApply = (selectedOptions,lastremoved) => {
  setFilterState(prevState => ({
    ...prevState,
    selectedOrgNameOptions: selectedOptions
  }));
  props.setColumnFilters(FILTER_KEYS.CUSTOMER,COLUMN_KEYS.ORG_NAME,selectedOptions);
};

const resetappliedFilter = () =>{
  handleOrgNameFilterReset();
  props?.resetColumnFilters(FILTER_KEYS.CUSTOMER)
}

  const headers =[
    <div ref={columnRef} className={`${styles.organisationName} ${styles.customwidth}`} key="organisationLegalName"><div className={styles.orgname}>Organisation Legal Name</div>
         <div className={styles.popup} ref={iconRef}  onClick={calculatePosition} style={{ float: "right" }}  >
           <img className={`${styles.filter} ${filterState.selectedOrgNameOptions?.length > 0? styles.activeFilter: ""}`} src={IMAGES.filtericon} onClick={() => setFilterState(prevState => ({ ...prevState, isOrgnameFilter: true }))} alt="Filter"/>
            {filterState.isOrgnameFilter && (
            <Filter  position={position} isOpen={filterState?.isOrgnameFilter} options={filterCustomers?.data?.map(item => ({ value: item?.uniqueCustomerRefId, label: item?.displayName,type: item?.serviceType}))} type={"serviceType"} onApply={handleOrgNameFilterApply} onRequestClose={() => setFilterState(prevState => ({ ...prevState, isOrgnameFilter: false }))} label={"Organisation Legal Name"} initialSelectedOptions={filterState?.selectedOrgNameOptions} onReset={resetappliedFilter} maxSelectionCount={3}/>)}
          </div>
    </div>,   
    <div className={styles.organisationName} key="serviceType"><div className={styles.orgname}>Service Type</div>
    {/* <img className={styles.filter} src={IMAGES.filtericon} onClick={() => setFilterState(prevState => ({ ...prevState, isServiceTypeFilter: true }))} alt="Filter"/> */}
    </div>,
    <div className={styles.organisationName} key="requestor"><div className={styles.orgname}>Requestor</div></div>,
    <div className={styles.organisationName} key="user"><div className={styles.orgname}>Users Count</div></div>,
    <div className={styles.organisationName} key="lastModifiedNo"><div className={styles.orgname}>Last Modified On</div>
    </div>,
];

const gotoDetail = (requestId,notificationId) => {
  setSearchKeyValue("");
  // navigate(`/user-management/customerdetail/${encodeURIComponent(requestId)}`);
  if(notificationId?.length>0){
    notificationId.forEach(id => {
      const payload = {
        read: true,
      };
      ReadNotification(payload, id)
    });
  }
}

const mappedData = list.map((item) => {
  const serviceType = item?.serviceSpecificDetails?.map((detail)=>detail?.serviceType?.label)
  const match = notificationdata?.find(row => row.detailsId === item?.uniqueCustomerRefId);
  const ids = filterAndMapIds(notificationdata, item?.uniqueCustomerRefId);
  const highlightClass = match ? styles.highlightedRow : '';
  const url = `/user-management/customerdetail/${encodeURIComponent(item.uniqueCustomerRefId)}`
  const tooltipContent =
      <DetailsTooltip
        countTooltipCss={"countTooltipCss"}
        data={{
          Total: item?.customerUserStatusCount?.total ? item?.customerUserStatusCount?.total : "0",
          Active: item?.customerUserStatusCount?.active ? item?.customerUserStatusCount?.active : "0",
          Inactive: item?.customerUserStatusCount?.inactive ? item?.customerUserStatusCount?.inactive : "0",
        }}
      />
  const userCount = `${item?.customerUserStatusCount?.total} | ${item?.customerUserStatusCount?.active} | ${item?.customerUserStatusCount?.inactive}`;
  return {
    organisationLegalName: <span className={`${styles.orglgname}  ${styles.posrelative} ${match?styles.boldid:""}`}><span className={`${highlightClass}`}></span><SecondaryTooltip text={match?.message?match.message:item.displayName} positions={['bottom', 'right']}><Link to={url} className= {`${styles.textoverflow} ${styles.custLink}`} onClick={()=>gotoDetail(item.uniqueCustomerRefId,ids)}>{item.displayName}</Link></SecondaryTooltip></span>,
    serviceType: <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip text={serviceType} positions={['bottom', 'right']}>{serviceType}</SecondaryTooltip></span>,
    requestor: <span className={`${styles.customDataContent} ${styles.textoverflow}`}><SecondaryTooltip copy={true} text={item.createdBy.email} positions={['bottom', 'right']}>{item.createdBy.name}</SecondaryTooltip></span>,
    // onBoardedOn: <span className={`${styles.customDataContent}`}><SecondaryTooltip text={formatDate(item.createdAt)} positions={['bottom', 'right']}>{formatDate(item.createdAt)}</SecondaryTooltip></span>
    user: <span className={`${styles.customDataContent}`}>
      <SecondaryTooltip text={tooltipContent} customCss={"userCountbody"} positions={['bottom', 'right']}>
        <div className={styles.userWrapper}>
          <div className={styles.totaluser}>Total: {item?.customerUserStatusCount?.total}</div>
          <div className={styles.countuser}>
            <div className={styles.activeuser}>Active: {item?.customerUserStatusCount?.active},</div>
            <div className={styles.inactiveuser}>Inactive: {item?.customerUserStatusCount?.inactive}</div>
          </div>
        </div>
      </SecondaryTooltip>
      </span>,
    lastModifiedNo:<div className={styles.modifiedonwrapper}><span className={`${styles.customDataContent}`}><SecondaryTooltip text={formatDate(item.modifiedAt)} positions={['bottom', 'right']}>{formatDate(item.modifiedAt)}</SecondaryTooltip></span><div className={styles.indicator}>
        <span className={styles.notificationmain}>{(item?.serviceSpecificDetails?.find((detail)=>detail?.serviceType?.value===Incident_Service_Type_Values.IPX_Service)&&!hasValidFincaTadigCode(item?.serviceSpecificDetails[0]))&&(<div className=""><SecondaryTooltip customCss={"customCss"} text={`The Invoice code is missing from this customer. It must be added to view the monthly customer invoices.`} positions={['bottom', 'right']}><img className={styles.Vector} src={IMAGES.Vector} alt=""/></SecondaryTooltip></div>)}</span>
        <span className={styles.notificationmain}>{(item?.serviceSpecificDetails?.find((detail)=>detail?.serviceType?.value===Incident_Service_Type_Values.IVC_Service)&&!hasOneItsmServiceName(item?.serviceSpecificDetails[0]))&&(<div className=""><SecondaryTooltip customCss={"customCss"} text={`The IVC service name is missing from this customer.`} positions={['bottom', 'right']}><img className={styles.Vector} src={IMAGES.Vector} alt=""/></SecondaryTooltip></div>)}</span>
          </div></div>,
  };
});

const handleOrgNameFilterReset = () => {
  setFilterState(prevState => ({
    ...prevState,
    isOrgnameFilter:false,
    selectedOrgNameOptions: [],
  }));
};

const filterByQuickSearch=(value)=>{
  setSearchKeyValue(value)
    const searchKey = value.trim();
    const cp_name = myRights?.cpName;
    const uniqueCustomerRefId = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
    let serviceFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
    const sort = `${sortConfig.field}:${sortConfig.order}`;
  getCustomerList(cp_name, searchKey, "", uniqueCustomerRefId,serviceFilter,sort);
}
  return (
    <>
      <div className={styles.infodetails}><img className={styles.circleinfo} src={IMAGES.infoCircle}/><span className={styles.infotext}>This section displays a list of all onboarded customers to the IPXplore portal, including their service type and onboarding date. To view detailed information about a customer, click on the organisation's legal name link, which will navigate you to the <span className={styles.boldtext}>'Detail'</span> page.</span></div>
      <React.Fragment>
        <div className={styles.wrapperchild}>
        <ChildContainer>
          <div className={styles.headContainer}>
            <div className={styles.search}>
             {/* <Search 
                 getSearchKeyValue={getSearchKeyValue}
                 placeholder="Search By Org. Legal Name"
                 onButtonClick={filterByQuickSearch}
                 searchKeyValue={searchKeyValue}
              /> */}
            </div>
            <SectionGuard canAccess={CAN(Action.CREATE,Resource.CUSTOMER_ACCESSR_REQUEST)}>
            <NewCustomer getCustomerList = {allCustomerList} />
            </SectionGuard>
            <SectionGuard canAccess={CAN(Action.LIST,Resource.RIGHTS_REPORT)}> 
            <div className={styles.wraper}>
            <SecondaryTooltip text={"Download User's Report"} positions={['bottom', 'right']}>
              <div className={`${props.userReport.loading ? styles.excelloading:styles.exceldownload}`} onClick={ ()=>{
                if(!props.userReport.loading){
                  handleDownload(props.userReport.data)
                }
              }  }><img src={IMAGES.downloadxlxs} className={styles.xlsxLogo}/></div>
            </SecondaryTooltip>
            </div>
          </SectionGuard>
          </div>
          {/* <div className={styles.wrapper}>
            {filterState.isServiceTypeFilter && (
              <div className={styles.popup}><Filter isOpen={filterState.isServiceTypeFilter} options={serviceType} onApply={handleServiceFilterApply} onRequestClose={() => setFilterState(prevState => ({ ...prevState, isServiceTypeFilter: false }))} label={"Service Type"} initialSelectedOptions={filterState.selectedServiceTypeptions} onReset={handleServiceTypeFilterReset} top="55px"left="38%"/></div>)}
          </div> */}
          {isLoading && <Loader />}
        {/* {
          !isLoading && list.length==0?
          <EmptyContainer>No Customer Found</EmptyContainer>:<></>
        } */}
            <div className={styles.sortstatus}>
              <Status statuses={services} onStatusChange={handleStatusChange} checkedStatuses={checkedStatuses} infoImage={IMAGES.infoCircle} label="Service" />
              <ListSorter options={CustomerSortOptions} sortConfig={sortConfig} onChange={setSortConfig}/>
            </div>
          <InfiniteScroll
            dataLength={list?.length} //This is important field to render the next data
            next={() =>  {
              if(!checkAllFalse(checkedStatuses)){
              // return getCustomerList(myRights.cpName, searchKeyValue.trim(), next);
              const uniqueCustomerRefId = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
              let serviceFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
              const sort = `${sortConfig.field}:${sortConfig.order}`;
              return getCustomerList(myRights.cpName, searchKeyValue.trim(), next, uniqueCustomerRefId,serviceFilter,sort);
              }
            }}
            hasMore={!checkAllFalse(checkedStatuses) ? next : null}
            loader={
                <Loader />
            }
          >
          {/* {list?.map((item, key) => (
            <div className={styles.container} key= {key}>
              <div className={styles.containerheader}>
                <Link className={styles.link} to={`/user-management?customerId=${encodeURIComponent(item.uniqueCustomerRefId)}`}>
                  <div className={styles.text}>{item.displayName}</div>
                </Link>
              </div>

              <div className={styles.wrapper}>
               
                  <div className={styles.parentDiv}>
                    <div className={styles.headData}>
                      <div className={styles.headSub}>Service Type</div>
                   <div className={styles.sub}>{item?.serviceSpecificDetails?.map((detail)=>detail.serviceType?.label).join(' & ')}</div>
                    </div>
                  </div>
                   <div className={styles.parentDiv}>
                    <div className={styles.headData}>
                      <div className={styles.headSub}>Onboarded By</div>
                      <div className={styles.sub}>{item.createdBy.name}</div>
                    </div>
                  </div>
                    <div className={styles.parentDiv}>
                    <div className={styles.headData}>
                      <div className={styles.headSub}>Onboarded On</div>
                      <div className={styles.sub}>{formatDate(item.createdAt)}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}   */}
            {(filterState.selectedOrgNameOptions.length > 0 || filterState.selectedServiceTypeptions.length>0) && (<AppliedFilter selectedFilterOptions={filterState?.selectedOrgNameOptions} selectedInvoicingPartyOptions={filterState?.selectedServiceTypeptions} onReset={resetappliedFilter}setSelectedFilterOptions={setFilterState} handleFilterApply={handleOrgNameFilterApply} firstFilterLabel={"Organisation Legal Name"} secondFilterLabel={"Service Type"}/>)}
           <Table headers={headers} data={checkAllFalse(checkedStatuses)?[]:mappedData} height={`${(mappedData?.length<8||checkAllFalse(checkedStatuses))&&(filterState?.isOrgnameFilter)?"480px":"auto"}`}  width="100%" columnConfig={computeWeightedWidths(customerListcolumnConfig)} isWidth={true} nodata={!isLoading && mappedData?.length===0?"No Data.":checkAllFalse(checkedStatuses)?"No Data.":<Loader/>}/>
             </InfiniteScroll>
        </ChildContainer>
        </div>
      </React.Fragment>
    </>
  );
};

export default CustomerViewer;
